/* istanbul ignore file */

export const environment = {
  production: false,
  api: {
    globalHost: "https://global.martech.qa",
    clientHost: "https://api.martech.qa",
  },
  auth: {
    url: "https://innovian.b2clogin.com/tfp/innovian.onmicrosoft.com/B2C_1_RegisterLogin/",
    clientId: "ef0653db-edbd-4660-bd76-cd4e669f04b3"
  },
  googleAnalyticsID: "UA-148732355-2",
  stripeKey: "pk_test_J0FlLGrlipMQwE0hFFDdqhyw00MGYqEpwO",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import "zone.js/dist/zone-error";
